/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_LinkInputs */

const cs_auth_signup_link = /** @type {(inputs: Auth_Signup_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemáte účet? Založte si kancelář`)
};

const en_auth_signup_link = /** @type {(inputs: Auth_Signup_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No account? Create your office`)
};

/**
* | output |
* | --- |
* | "No account? Create your office" |
*
* @param {Auth_Signup_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_link = /** @type {((inputs?: Auth_Signup_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_link(inputs)
	return cs_auth_signup_link(inputs)
});